<div class="row">
  <div class="flex justify-end">
    <button mat-flat-button color="primary" (click)="addBlankDevice()" size="2x">Add Device</button>
  </div>
</div>

<form [formGroup]="parentForm" *ngIf="parentForm" (change)="setDirtyForm()">
  <ng-container formArrayName="devices">
    <div *ngFor="let device of devices.controls; index as i" style="width: 40rem;">
      <mat-accordion>
        <mat-expansion-panel>
          <mat-expansion-panel-header>
            <mat-panel-title>
              {{(device.get('deviceName').value) ? device.get('deviceName').value : 'New Device'}}
            </mat-panel-title>
          </mat-expansion-panel-header>
          <div [formGroup]="device">
            <input id="id{{i}}" formControlName="id" type="text" hidden/>
            <div class="flex justify-end">
              <mat-icon matTooltip="Remove device" matTooltipPosition="right" (click)="removeDevice(i)" style="cursor: pointer">close</mat-icon>
            </div>
            <div class="flex flex-wrap" style="gap: 20px">
              <mat-form-field appearance="outline">
                <mat-label for="deviceName{{i}}">Device Name</mat-label>
                <input matInput id="deviceName{{i}}" formControlName="deviceName" type="text" class="form-control"/>
              </mat-form-field>
              <mat-form-field appearance="outline">
                <mat-label>System Type</mat-label>
                <mat-select formControlName="systemType" id="systemType{{i}}">
                  <mat-option *ngFor="let item of batteries" [value]="item.value">
                    {{ item.key }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
              <mat-form-field appearance="outline">
                <mat-label for="namePlateEnergy{{i}}">Nameplate Energy (kWh)</mat-label>
                <input matInput id="namePlateEnergy{{i}}" type="number" class="form-control" readonly value="{{device.get('namePlateEnergy').value}}">
                <mat-icon matSuffix matTooltip="Nameplate Energy is calculated based on battery type and number of racks">
                  info
                </mat-icon>
                <mat-hint>Readonly</mat-hint>
              </mat-form-field>
              <mat-form-field appearance="outline">
                <mat-label for="usableEnergy{{i}}">Usable Energy (kWh)</mat-label>
                <input matInput id="usableEnergy{{i}}" type="number" class="form-control" readonly value="{{ device.get('usableEnergy').value}}">
                <mat-icon matSuffix matTooltip="Usable Energy is calculated as Nameplate Energy * (Max SOC - Min SOC) * SOH.">
                  info
                </mat-icon>
                <mat-hint>Readonly</mat-hint>
              </mat-form-field>
              <mat-form-field appearance="outline">
                <mat-label for="configuredPower{{i}}">Configured Power (kW)</mat-label>
                <input matInput id="configuredPower{{i}}" formControlName="configuredPower" type="text" class="form-control"/>
              </mat-form-field>
              <mat-form-field appearance="outline">
                <mat-label for="numberOfRacks{{i}}">Number of Racks</mat-label>
                <input matInput id="numberOfRacks{{i}}" formControlName="numberOfRacks" type="number" class="form-control"/>
              </mat-form-field>
              <mat-form-field appearance="outline">
                <mat-label for="minimumSoc{{i}}">Minimum SOC</mat-label>
                <input matInput id="minimumSoc{{i}}" formControlName="minimumSoc" type="number" class="form-control"/>
              </mat-form-field>
              <mat-form-field appearance="outline">
                <mat-label for="maxSoc{{i}}">Max SOC</mat-label>
                <input matInput id="maxSoc{{i}}" formControlName="maxSoc" type="number" class="form-control"/>
              </mat-form-field>
              <mat-form-field appearance="outline">
                <mat-label for="stateOfHealth{{i}}">State Of Health (SOH)</mat-label>
                <input matInput id="stateOfHealth{{i}}" formControlName="stateOfHealth" type="number" class="form-control"/>
              </mat-form-field>
            </div>
          </div>
        </mat-expansion-panel>
      </mat-accordion>
    </div>
    <br />
  </ng-container>
  @if (devices.controls.length) {
    <div class="flex items-center justify-end" style="margin-top: 1rem">
      <button mat-flat-button color="primary" (click)="saveStorage()" [disabled]="!parentForm.valid" style="margin-right: 1rem">Save</button>
      <button mat-flat-button color="warn" (click)="cancel()" >Cancel</button>
    </div>
  }
</form>
